import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransitDataReducer } from 'types/mainPage';

const initialState: TransitDataReducer = {
  ateCity: 0,
  ateCityType: '',
  ateRegion: 0,
  ateRegionType: '',
  ateVC: 0,
  dataset: 0,
  layer: 0,
  from: 'layers',
  needShowAte: false,
};

export const transitDataSlice = createSlice({
  initialState,
  name: 'transitData',
  reducers: {
    setTransitData(_, action: PayloadAction<TransitDataReducer>) {
      return action.payload;
    },
    setNeedShowAte(state, action: PayloadAction<boolean>) {
      state.needShowAte = action.payload;
    },
    resetTransitionData(_, action: PayloadAction<string>) {
      return {
        ...initialState,
        from: action.payload,
      };
    },
  },
});

export default transitDataSlice.reducer;
